// Courtesy of
// https://stackoverflow.com/questions/42199956/how-to-implement-debounce-in-vue2
export function debounce(fn, delay) {
  var timeoutID = null;
  return function() {
    clearTimeout(timeoutID);
    var args = arguments;
    var that = this;
    timeoutID = setTimeout(function() {
      fn.apply(that, args);
    }, delay);
  };
}

// Example usage:
// <script>
// import debounce from './helpers'
// export default {
//   data () {
//     return {
//       input: '',
//       debouncedInput: ''
//     }
//   },
//   watch: {
//     input: debounce(function (newVal) {
//       this.debouncedInput = newVal
//     }, 500)
//   }
// }
// </script>
